import { useEffect, useState } from "react";
import { Input } from "../../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { PageHeader, Card, Loading, Pager, EmptyState } from "../../components/common";
import { api } from "../../lib/api";
import { fmtDateTime } from "../../lib/format";

export default function AuditLog() {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  useEffect(() => { const t = setTimeout(() => api.get("/admin/audit", { params: { q, page } }).then((r) => setData(r.data)), 250); return () => clearTimeout(t); }, [q, page]);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Every sensitive administrator action is recorded here and cannot be edited." />
      <Input data-testid="audit-search" placeholder="Search action (e.g. commission, order.status) or admin email" value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} className="mb-4 h-11 sm:max-w-md" />
      {!data ? <Loading /> : data.items.length === 0 ? <EmptyState title="No audit entries" /> : (
        <Card className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Admin</TableHead><TableHead>Action</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
            <TableBody>{data.items.map((a) => (
              <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                <TableCell className="whitespace-nowrap text-sm">{fmtDateTime(a.created_at)}</TableCell>
                <TableCell className="text-sm">{a.actor_email}</TableCell>
                <TableCell><span className="rounded bg-slate-100 px-2 py-0.5 font-mono text-xs">{a.action}</span></TableCell>
                <TableCell className="max-w-[480px] text-xs text-slate-600">{Object.entries(a.details || {}).map(([k, v]) => (
                  <div key={k} className="break-words"><span className="font-semibold text-slate-700">{k.replace(/_/g, " ")}:</span> {typeof v === "object" ? Object.entries(v || {}).map(([k2, v2]) => `${k2}: ${typeof v2 === "object" ? `${v2?.from ?? "—"} → ${v2?.to ?? "—"}` : v2}`).join(" · ") || "—" : String(v)}</div>
                ))}</TableCell>
              </TableRow>))}</TableBody>
          </Table>
          <div className="px-4 pb-4"><Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} /></div>
        </Card>
      )}
    </div>
  );
}
